import { useState } from "react";
import { Agent } from "../sharedTypes";

export const useCurrentUser = () => {
  const [user] = useState<Agent | null>(() => {
    const storedUser = localStorage.getItem("userData");
    if (storedUser) {
      try {
        return JSON.parse(storedUser);
      } catch (error) {
        console.error("Failed to parse user data from localStorage", error);
        return null;
      }
    }
    return null;
  });

  return user;
};
